/* eslint-disable */

import { Switch } from "antd";
import moment from "moment";
import { PiDotsThreeOutlineVerticalBold } from "react-icons/pi";
import { URL_LANDING } from "../../../services/api/config";
import { FaEye } from "react-icons/fa";

export const columnsData = (
  { handleChangeStatus, handleChangeDisplayStatus, navigate },
  pageMenu
) => {
  return [
    {
      title: "Tên biểu mẫu",
      dataIndex: "name",
      key: "name",
      width: 250,
      render: (text, record, index) => {
        return (
          <div
            style={{
              color: "rgb(56, 114, 174)",
              fontWeight: "bold",
              cursor: pageMenu.details ? "pointer" : "unset",
            }}
            onClick={() =>
              pageMenu.details && navigate(`/form-details/${record.id}`)
            }
          >
            {text}
          </div>
        );
      },
    },
    {
      title: "Utm source",
      dataIndex: "utm_source",
      key: "utm_source",
      width: 150,
      render: (text, record, index) => {
        return (
          <div
            style={{
              color: "rgb(56, 114, 174)",
              fontWeight: "bold",
            }}
          >
            {text}
          </div>
        );
      },
    },

    {
      title: "Mã đại lý",
      dataIndex: "branch_code",
      key: "branch_code",
      width: 100,
      render: (text, record, index) => {
        return (
          <div style={{ color: "rgb(56, 114, 174)" }}>
            {record?.branch_info?.branch_code || "-"}
          </div>
        );
      },
    },
    {
      title: "Ngày mở",
      dataIndex: "start_at",
      key: "start_at",
      width: 120,
      render: (text, record, index) => {
        return (
          <div
            style={{
              color: "rgb(56, 114, 174)",
              fontWeight: "bold",
            }}
          >
            <div>
              {record?.start_at
                ? moment(record?.start_at).format("YYYY-MM-DD HH:mm:ss")
                : "-"}
            </div>
          </div>
        );
      },
    },
    {
      title: "Ngày đóng",
      dataIndex: "end_at",
      key: "end_at",
      width: 120,
      render: (text, record, index) => {
        return (
          <div
            style={{
              color: "rgb(56, 114, 174)",
              fontWeight: "bold",
            }}
          >
            <div>
              {record?.end_at
                ? moment(record?.end_at).format("YYYY-MM-DD HH:mm:ss")
                : "-"}
            </div>
          </div>
        );
      },
    },
    {
      title: "Ngày chốt doanh thu",
      dataIndex: "end_form_answer_at",
      key: "end_form_answer_at",
      width: 160,
      render: (text, record, index) => {
        return (
          <div
            style={{
              color: "rgb(56, 114, 174)",
              fontWeight: "bold",
            }}
          >
            <div>{moment(record.end_form_answer_at).format("YYYY-MM-DD")}</div>
          </div>
        );
      },
    },
    {
      title: "Doanh thu (USD)",
      dataIndex: "total_revenue",
      key: "total_revenue",
      width: 140,
      render: (text, record, index) => {
        return (
          <div
            style={{
              color: "rgb(56, 114, 174)",
              fontWeight: "bold",
            }}
          >
            {text?.toFixed(2)}
          </div>
        );
      },
    },

    {
      title: "Người tạo",
      dataIndex: "created_by_user_info",
      key: "created_by_user_info",
      width: 140,
      render: (text, record, index) => {
        return (
          <div style={{ color: "rgb(56, 114, 174)" }}>
            {record?.created_by_user_info?.name}
          </div>
        );
      },
    },
    {
      title: "Người cập nhật cuối",
      dataIndex: "updated_by_user_info",
      key: "updated_by_user_info",
      width: 170,
      render: (text, record, index) => {
        return (
          <div style={{ color: "rgb(56, 114, 174)" }}>
            {record?.updated_by_user_info?.name}
          </div>
        );
      },
    },
    {
      title: "Ngày tạo",
      dataIndex: "role",
      key: "role",
      width: 120,
      render: (text, record, index) => {
        return (
          <div onClick={() => console.log("da push code moi nhat")}>
            {moment(record.created_at).format("YYYY-MM-DD HH:mm:ss")}
          </div>
        );
      },
    },
    {
      title: "T/thái hoạt động",
      dataIndex: "status",
      key: "status ",
      width: 140,
      render: (text, record, index) => {
        return (
          <Switch
            checked={text === "ACTIVE" ? true : false}
            disabled={!pageMenu.update}
            onChange={(e) => pageMenu.update && handleChangeStatus(e, record)}
          />
        );
      },
    },
    {
      title: "T/thái hiển thị",
      dataIndex: "display_status",
      key: "status",
      width: 140,
      render: (text, record, index) => {
        return (
          <Switch
            checked={record?.display_status === "ACTIVE" ? true : false}
            disabled={!pageMenu.update || record?.status === "INACTIVE"}
            onChange={(e) =>
              pageMenu.update &&
              record?.status === "ACTIVE" &&
              handleChangeDisplayStatus(e, record)
            }
          />
        );
      },
    },
    {
      title: "Preview",
      dataIndex: "status",
      key: "status",
      align: "center",
         width:80,
      render: (text, record, index) => {
        return (
          <a
            href={`${URL_LANDING}/form-preview?utm_source=${record?.utm_source}`}
            target="_blank"
          >
            <FaEye size={24} style={{ cursor: "pointer" }} />
          </a>
        );
      },
    },
    // {
    //   title: "Thao tác",
    //   dataIndex: "status",
    //   key: "status",
    //   width: "15%",
    //   align: "center",
    //   render: (text, record, index) => {
    //     return (
    //       <PiDotsThreeOutlineVerticalBold
    //         size={24}
    //         style={{ cursor: "pointer" }}
    //       />
    //     );
    //   },
    // },
  ];
};
